export default {
  'receipt.title': 'Informations sur le reçu',
  'receipt.btn.add': 'Ajouter un reçu',
  'receipt.btn.import': "Reçu d'importation",
  'receipt.btn.export': "Reçu d'exportation",
  'receipt.input.placeholder': 'Veuillez entrer le reçu',
};
